import VueRouter from 'vue-router'
import Index from './components/General/index'
export default new VueRouter({
    hashbang: false,
    mode: 'history',
    routes:[
        {
            path:'/',
            component: Index
        },
        {
            path:'/Reg',
            component: () => import("./components/Reg")
        },
        {
            path:"/Lk/:n",
            component: () => import("./components/Lk")
        },
        {
            path:'/Projects',
            component: () => import("./components/project")
        },
        {
            path:'/Search',
            component: () => import("./components/Search")
        },
        {
            path:'/Message/:n',
            component: () => import("./components/Message")
        },
        {
            path:'/Messagen/:e',
            component: () => import("./components/Message/Message")
        },
        {
            path:'/:idName',
            component: () => import('./components/Cards')
        },
        
    ]
})